import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    DynamicTable,
    customColumnProps,
} from "@maherunlocker/custom-react-table";
import { useSnapshot } from "valtio";

import { CustomSideFilter } from "./CustomSideFilter";
import { CustomIcons } from "./CustomIcons";

import { store } from "../../../../components/VerticalLayout/store";

import {
    store as serviceStore,
    setLocalShop,
    setIsAssociateServiceOpened,
    setIsHistoryShopsModalOpened,
    setSelectedServices,
    setIdsLocalShop,
    setShopsServiceData,
    setShopsSelectedRow,
    setNumberArchiveMultiShop,
    setNumberActiveMultiShop,
    setServiceStoreArchived,
} from "../store";

import { removeArrayOfObjectsDuplicates } from "@helpers/general";

import HistoryModal from "../HistoryModal";
import { ServiceAssociateModal } from "./ServiceAssociateModal";

import "./index.css";
import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";

type servicesFranchisesType = {
    isServicesArchived: boolean;
    setIsServicesArchived: Function;
};
export default function ServicesShops({
    isServicesArchived,
    setIsServicesArchived,
}: servicesFranchisesType) {
    const { oneShop, userID, franchiseID } = useSnapshot(store);
    const {
        isAssociateServiceOpened,
        localShop,
        isHistoryShopsModalOpened,
        isValidateClicked,
        isHistoryModalOpened,
    } = useSnapshot(serviceStore);

    const { t } = useTranslation();
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const [data, setData] = React.useState<any>({});
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );

    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [isShopSelected, setIsShopSelected] = React.useState<boolean>(false);

    const [isUpdatedModification, setIsUpdatedModification] = React.useState<
        boolean
    >(false);

    const [service, setService] = useState<any[]>([]);

    const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
    const uuidUser = localStorage.getItem("uuidUser");

    const urlArchive: string = `${process.env.REACT_APP_API_V2_URL}/settings/general/services?userId=${userID}&franchiseId=${franchiseID}&type=archived&uuidUser=${uuidUser}`;

    const urlActive: string = `${process.env.REACT_APP_API_V2_URL}/settings/general/services?userId=${userID}&franchiseId=${franchiseID}&type=activated&uuidUser=${uuidUser}`;

    const ActionColumn = (e: any) => {
        return e.selectedRow.subRows === undefined ? <div></div> : null;
    };

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: oneShop ? 6 : 7,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    selectedRowData={e}
                    setDataIsUpdated={setDataIsUpdated}
                    isServicesArchived={isServicesArchived}
                    selectedRows={selectedRows}
                />
            ),
            disableFilter: false,
        },
        {
            indexOFColumn: 2,
            columnName: t("Designation"),
            customJsx: (e: any) => <NumberService e={e} />,
            filterName: t("Designation"),
            canFilter: true,
        },
        {
            indexOFColumn: 6,
            columnName: t("Tag"),
            customJsx: (e: any) => <Tag e={e} />,
            filterName: t("Tag"),
            canFilter: true,
        },
    ];

    function NumberService(e: any) {
        return (
            <React.Fragment>
                {e.e.selectedRow?.subRows !== undefined ? (
                    <h6 className="badge__clz srv_icn_BTcounter">
                        {e.e.selectedRow[t("Shop")] !== ""
                            ? e.e.selectedRow.subRows?.length
                            : 0}
                    </h6>
                ) : (
                    e.e.selectedRow[t("Designation")]
                )}
            </React.Fragment>
        );
    }
    function Tag(e: any) {
        return (
            <React.Fragment>
                {e.e.selectedRow?.subRows !== undefined
                    ? ""
                    : e.e.selectedRow[t("tag")]}
            </React.Fragment>
        );
    }
    React.useEffect(() => {
        if (isValidateClicked) {
            setDataIsUpdated(true);
        }
    }, [isValidateClicked]);

    React.useEffect(() => {
        if (!isHistoryModalOpened) {
            setDataIsUpdated(true);
        }
        // eslint-disable-next-line
    }, [!isHistoryModalOpened]);

    useEffect(() => {
        setServiceStoreArchived(data?.othersData?.listServices);
    }, [data?.othersData]);
    React.useEffect(() => {
        let localShop: string[] = [];
        let idsLocalShop: string[] = [];

        selectedRows.forEach((el: any) => {
            if (el[t("Shop")] !== "" && el[t("Shop")] !== undefined)
                localShop.push(el.shopId);
            for (let i in el.subRows) {
                idsLocalShop.push(el.subRows[i].Id);
            }
        });

        setIdsLocalShop(idsLocalShop);
        setLocalShop(localShop);
        setIsShopSelected(localShop.length !== 0);
    }, [selectedRows, t]);
    React.useEffect(() => {
        let array: any = [];
        selectedRows.forEach((element: any) => {
            if (element[t("Shop")] !== undefined) {
                element.subRows.forEach((el: any) => {
                    array.push({ [el.shopId]: el.Id });
                });
            } else {
                array.push({ [element.shopId]: element.Id });
            }
        });
        setShopsSelectedRow(selectedRows);

        setSelectedServices(removeArrayOfObjectsDuplicates(array));
    }, [selectedRows, t]);

    React.useEffect(() => {
        let localShop: string[] = [];
        selectedRows.forEach((el: any) => {
            if (el[t("Shop")] !== "" && el[t("Shop")] !== undefined)
                localShop.push(el[t("Shop")]);
        });

        setIsShopSelected(localShop.length >= 1);

        let localArchivedService: number = 0;
        let localActiveService: number = 0;

        if (selectedRows.length > 0) {
            selectedRows.forEach((element: any) => {
                if (element[t("Shop")] !== undefined) {
                    localActiveService += element?.serviceNumber.activated;
                    localArchivedService += element?.serviceNumber.archived;
                }
            });
            if (selectedRows.filter((el: any) => el[t("Shop")]).length > 0) {
                setNumberActiveMultiShop(localActiveService);
                setNumberArchiveMultiShop(localArchivedService);
            } else {
                setNumberActiveMultiShop(
                    data.othersData !== undefined
                        ? data.othersData.activated
                        : 0
                );
                setNumberArchiveMultiShop(
                    data.othersData !== undefined ? data.othersData.archived : 0
                );
            }
        } else {
            setNumberActiveMultiShop(
                data?.othersData !== undefined ? data?.othersData?.activated : 0
            );
            setNumberArchiveMultiShop(
                data?.othersData !== undefined ? data?.othersData?.archived : 0
            );
        }
    }, [selectedRows, data, t]);

    useEffect(() => {
        setShopsServiceData(
            data !== undefined && data.data !== undefined ? data?.data : []
        );
    }, [data]);
    useEffect(() => {
        if (isUpdatedModification) {
            setDataIsUpdated(true);
        }
    }, [data, isUpdatedModification]);
    return (
        <React.Fragment>
            <div
                style={{
                    display: "grid",
                    minHeight: oneShop ? "650px" : "600px",
                    gridTemplateColumns: "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
            >
                <DynamicTable
                    url={isServicesArchived ? urlArchive : urlActive}
                    canExpand
                    canSelect
                    setData={setData}
                    customSelect
                    requestHeader={{ "Accept-Language": i18nextLng }}
                    setSelectedRows={setSelectedRows}
                    customJsxSideFilterButton={
                        <CustomSideFilter
                            isShopSelected={isShopSelected}
                            setService={setService}
                            selectedRows={selectedRows}
                            service={service}
                            setDataIsUpdated={setDataIsUpdated}
                            setLocalFilterActive={setLocalFilterActive}
                            setIsServicesArchived={setIsServicesArchived}
                            isServicesArchived={isServicesArchived}
                        />
                    }
                    canResize
                    showGlobalFilter
                    showFilter
                    canMovedCheckboxLeftOnExpand
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    actionColumn={ActionColumn}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    elevationTable={1}
                    minHeight={oneShop ? "500px" : "450px"}
                    maxHeight={oneShop ? "500px" : "450px"}
                    name="Service"
                />
                {isAssociateServiceOpened ? (
                    <ServiceAssociateModal
                        idShops={localShop}
                        setIsAssociateServiceOpened={
                            setIsAssociateServiceOpened
                        }
                        setGlobalDataUpdated={setDataIsUpdated}
                        setIsUpdatedModification={setIsUpdatedModification}
                        selectedShopsRows={selectedRows}
                        isAssociateServiceOpened={isAssociateServiceOpened}
                    />
                ) : null}
            </div>
            {isHistoryShopsModalOpened ? (
                <HistoryModal
                    ids={selectedRows}
                    setIsModalOpened={setIsHistoryShopsModalOpened}
                    isModalOpened={isHistoryShopsModalOpened}
                    setGlobalDataUpdated={setDataIsUpdated}
                />
            ) : null}
        </React.Fragment>
    );
}
